export const API_TYPES = {
  chartingNoncompliance: "charting-noncompliance",
  deepLink: "deep-link",
  distributionUrl: "distribution-url",
  documents: "documents",
  interview: "interview",
  interviewAvailability: "interview-availability",
  interviewSettings: "interview-settings",
  openHouse: "open-house",
  hiringEvent: "hiring-event",
  newsFeedItem: "news-feed-item",
  paySurveyResponse: "pay-survey-response",
  placement: "placement",
  placementApplication: "placement-application",
  placementCandidate: "placement-candidate",
  placementCandidateBan: "placement-candidate-ban",
  referral: "referral",
  sheet: "sheet",
  shift: "shift",
  shiftBoost: "shift-boost",
  worker: "worker",
  workplace: "workplace",
  workplaceUser: "workplace-user",
  workplaceSearchResult: "workplace-search-result",
  workerRequirement: "worker-requirement",
  requirement: "requirement",
  incentive: "incentive",
  hireReport: "hire-report",
  workerEvent: "worker-event",
  hiringFeedStats: "hiring-feed-stats",
  placementCandidateScreening: "placement-candidate-screening",
  tag: "tag",
  workerFavoritePlacement: "worker-favorite-placement",
  helloSignSession: "hello-sign-sessions",
  eSignWorkflowSession: "esign-workflow-session",
  workConfirmationLetterEmail: "work-confirmation-letter-email",
  disputePresignedUrl: "dispute-presigned-url",
  signedJobSearchAgreement: "signed-job-search-agreement",
  jobSearchAgreementEmail: "job-search-agreement-email",
  interviewAttendanceVerification: "interview-attendance-verification",
  interviewAttendanceVerificationUploadPresignedUrl:
    "interview-attendance-verification-upload-presigned-url",
  interviewUpdateEta: "interview-update-eta",
  workBadgeEmail: "work-badge-email",
  workBadgePresignedUploadUrl: "work-badge-presigned-upload-url",
  badgeOrder: "badge-order",
} as const;
